import { Component, OnInit } from '@angular/core';

import { UserInfoStateStructure, LOGIN_INFO_REDUCER_NAME, LoggedInUserInformationService } from '@ptl/account-management';
import { Brand, BrandingConfigurationService } from '@ptl/brand';
import { PtlMaskService } from '@ptl/forms';
import { PtlNotificationService } from '@ptl/global-components';
import { ReducerUtilityService } from '@ptl/state';
import { AxwayAuthenticationService } from '@ptl/xhr';
import { NgRedux } from '@ptl/angular-redux-store';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    providers: [],
    standalone: false
})
export class AppComponent implements OnInit {

  title = 'shopx' ;
  testVal = null;
  testData: UserInfoStateStructure = null;
  testBrand: Brand = null;
  testAxway = null;
  testState = null;
  testForm = null;
  testRedux = null;

  constructor(
    private loggedInUserService: LoggedInUserInformationService,
    private brandingService: BrandingConfigurationService,
    private notificationService: PtlNotificationService,
    private axwayAuthService: AxwayAuthenticationService,
    private reducerUtilityService: ReducerUtilityService,
    private ptlMaskService: PtlMaskService,
    private ngRedux: NgRedux<AppComponent>
  ) {
  }

  ngOnInit() {
    this.testVal = LOGIN_INFO_REDUCER_NAME;

    this.testData = this.loggedInUserService.getUserData();

    this.testBrand = this.brandingService.getCurrentBrand();

    this.testAxway = this.axwayAuthService.isTokenValid();

    this.testState = this.reducerUtilityService.getApplicationStates();

    this.testForm = this.ptlMaskService.isPhoneMask('');

    this.testRedux = this.ngRedux.getState()

    this.notificationService.open({
      content: 'content',
      primaryButtonText: 'button'
    });
  }
}
